import * as React from "react";
import { connect } from "react-redux";
import { Container, Dropdown, Accordion, Card, Button, Form , Spinner,OverlayTrigger,Tooltip} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { PartTemplateService } from "../../Common/Services/PartTemplateService";
import paginationFactory from 'react-bootstrap-table2-paginator';
import  ProductSlideout  from './ProductSlideout';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import _ from "lodash";
import { confirmAlert } from "react-confirm-alert";
// import { SortableContainer, SortableElement,SortableHandle } from "react-sortable-hoc";
import createDOMPurify from "dompurify";
// import { arrayMove } from 'react-sortable-hoc';
import "react-confirm-alert/src/react-confirm-alert.css";
import { faArrowUp, faListSquares } from "@fortawesome/free-solid-svg-icons";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { FaArrowUpFromBracket,  FaCirclePlus, FaEllipsis,FaCircleMinus  } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import * as XLSX from "xlsx";
import { PROCESS_MASTER_TEMPLATE_ROWS } from "./ProcessMasterImportTemplateData";
import { extractValidationErrors } from "../../Common/Utilities/ErrorHandler";
import "../../Modules/customer.scss";
class ProcessMaster extends React.Component<any, any> {
    private importFileInputRef: React.RefObject<HTMLInputElement>;

    constructor(props: any) {
        super(props);
        this.importFileInputRef = React.createRef<HTMLInputElement>();
        this.state = {
          tableRefresh: false,
          htmlItem: [],
          htmlErrorItem: [],
          htmlWarningItem: [],
          searcResult: [],
          productid:0,
          isSaveOpen: false,
          loading: false,
          isWait: false,
          duplicateSrNos: [] as number[],
          newRow:
          {id:0,processName:"",pDescription:"",srno:0,status:1,isFixed:0,ledgercode:"",deleteAllowed:true},
          formData :{processlist:[],},
        };
        
     
      }

     
    
      componentDidMount() {
        let requestlist = { ...this.state.requestlist };
        this.getprocessMaster(requestlist);
      }

     componentDidUpdate(prevProps) {
      if (prevProps.permissions !== this.props.permissions) {
        this.setState({ tableRefresh: !this.state.tableRefresh });
      }
    }


      handleRowOrdering = (e: any, row: any, type: any) => {

let isSaveOpen =true;
        let searcResult = this.state.searcResult;
        
        let nextOrderNo = type == 'down' ? row.srno + 1 : row.srno - 1;
        let currentRow = searcResult.filter((x) => x.srno == row.srno);
        let nextRow = searcResult.filter((x) => x.srno == nextOrderNo);
    
        if (nextRow != null && nextRow.length > 0) {
    
          nextRow[0].srno = row.srno;
          currentRow[0].srno = nextOrderNo;
    
    
          searcResult = searcResult.sort((a, b) => a.srno - b.srno);
    
          this.setState({ searcResult: searcResult }, () => {
            this.setState({ searcResult: searcResult,isSaveOpen:isSaveOpen });
          });
    
         // this.ReorderProcess();
        }
    
      };
      ReorderProcess = () => {
        
        let request = { ...this.state.requestlist };
        let searcResult = this.state.searcResult;
        searcResult.forEach((element, idx) => {
          //searcResult.forEach(element => {
          let item: any = {};

          item.Id = element.id ==null ?0 :element.id ;
          item.ProcessName = element.processName;
          item.srno =idx;
          item.PDescription = element.pDescription;
          item.Tenantid = element.tenantid;
          item.status=element.status;
          item.isFixed = element.isFixed;
          item.ledgercode=element.ledgercode;

        
          this.state.formData.searcResult.push(item);
        });
    
    
    
      
      };
    
      
      sortByKey = (array: any, key: any) => {
        return array.sort((a, b) => {
          let x = parseInt(a[key]);
          let y = b[key];
          return x < y ? -1 : x > y ? 1 : 0;
        });
      };
      // startState = () => { };
      // onSortMove = () => { };
      // onSortEnd = ({ oldIndex, newIndex }) => {
      //   
      //   if (newIndex !== oldIndex) {
      //     this.setState({ isSaveOpen: true }, () => {
      //        //this.props.changeValueFuntion(true);
      //     });
      //   }
      //   this.setState({ isWait: false });
      //   this.setState(({ searcResult }) => ({
      //      searcResult: arrayMove(searcResult, oldIndex, newIndex),
      //   }));
      // };

      updateState = (e: any, srno: any, type: any, txtID) => {
        if (this != undefined) {
          let isStateChanged = true;
          let isSaveOpen =true;
          let start = e.target?.selectionStart;
          let end = e.target?.selectionEnd;
          let searcResult = Object.assign(
            [],
            JSON.parse(JSON.stringify(this.state.searcResult))
          );
          // Resolve by srno so pagination rowIndex does not update the wrong row
          const index = searcResult.findIndex(
            (x: any) => Number(x.srno) === Number(srno)
          );
          if (index < 0) {
            return;
          }
    
        
          if (type === "processName") {
            
            searcResult[index].processName = e.target.value;
    
            this.setState({ searcResult, isStateChanged,isSaveOpen, duplicateSrNos: [] }, () => {
              $("input[id^='txtprocess" + txtID + "txt']").focus();
              
            let txtdesc =  $("input[id^='txtprocess" + txtID + "txt']")[0] as any;
            if (txtdesc !== null && txtdesc !== undefined) {
              txtdesc.selectionStart = start;
              txtdesc.selectionEnd = end;
            }
            });
          }
          if (type === "ledgercode") {
            
            searcResult[index].ledgercode = e.target.value;
    
            this.setState({ searcResult, isStateChanged,isSaveOpen }, () => {
              $("input[id^='txtledgercode" + txtID + "txt']").focus();
              
            let txtdesc =  $("input[id^='txtledgercode" + txtID + "txt']")[0] as any;
            if (txtdesc !== null && txtdesc !== undefined) {
              txtdesc.selectionStart = start;
              txtdesc.selectionEnd = end;
            }
            });
          }
          if (type === "Description") {
    
            searcResult[index].pDescription = e.target.value;
    
            this.setState({ searcResult, isStateChanged,isSaveOpen, duplicateSrNos: [] }, () => {
              $("input[id^='txtdes" + txtID + "txt']").focus();
              let txtdesc =  $("input[id^='txtdes" + txtID + "txt']")[0] as any;
            if (txtdesc !== null && txtdesc !== undefined) {
              txtdesc.selectionStart = start;
              txtdesc.selectionEnd = end;
            }
            });
          }
          
          if (type === "status") {
            
            if(e.target.checked)
            {
              
             // $("input[id^='txtstatus" + txtID + "txt']").isChecked =true;
            searcResult[index].status =1;
            }
          else
          {
           searcResult[index].status =0;
          }
            this.setState({ searcResult, isStateChanged,isSaveOpen }, () => {
            
             
            });
          }

          if (type === "IsFixed") {
            
            if(e.target.checked)
            {
              
             // $("input[id^='txtstatus" + txtID + "txt']").isChecked =true;
            searcResult[index].isFixed =1;
            }
          else
          {
           searcResult[index].isFixed =0;
          }
            this.setState({ searcResult, isStateChanged,isSaveOpen }, () => {
            
             
            });
          }
       
        }
      };

      removeRowFromState = (row: any) => {
        let searcResult = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.searcResult || []))
        );
        const searcResultc = searcResult
          .filter((item) => item.srno !== row.srno)
          .map((item, index) => {
            item.srno = index + 1;
            return item;
          });
        this.setState({ searcResult: [] }, () => {
          this.setState({ searcResult: searcResultc });
        });
      };

      deleteProcess = (row: any) => {
        let request = { ...this.state.requestlist };
        request.processId = row.id;

        PartTemplateService.DeleteProcess(request)
          .then(async (result: any | null) => {
            if (result === true) {
              this.removeRowFromState(row);
              toast.success("Process has been deleted.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "userManagementHierarchy",
              });
            } else {
              toast.error("Process cannot be deleted. It may be used in a job.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "userManagementHierarchy",
              });
              let requestlist = { ...this.state.requestlist };
              this.getprocessMaster(requestlist);
            }
            resolve();
          })
          .catch((error) => {
            toast.error("Failed to delete process.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "userManagementHierarchy",
            });
            let requestlist = { ...this.state.requestlist };
            this.getprocessMaster(requestlist);
            reject();
          });
      };

      ishandleDeleteRow(row: any, mode: any) {
        if (!mode) {
          return;
        }

        // Unsaved new rows are removed locally only
        if (!row.id || row.id <= 0) {
          this.removeRowFromState(row);
          return;
        }

        this.deleteProcess(row);
      }
      
      handleNewRow = () => {
        let searcResult: any = [];
        let newRow: any = {};
        let isStateChanged = true;
        let isSaveOpen = true;
    
        searcResult = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.searcResult || []))
        );
        newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));
    
        let maxSrno = searcResult.length > 0
          ? Math.max(...searcResult.map((o) => Number(o.srno) || 0), 0)
          : 0;
        newRow.id = 0;
        newRow.srno = maxSrno + 1;
        newRow.deleteAllowed = true;
        searcResult.push(newRow);
        this.setState({ searcResult: [] }, () => {
          this.setState({ searcResult: searcResult, isStateChanged, isSaveOpen });
        });
      };


      getprocessMaster = (requestlist: any) => {
 

        PartTemplateService.GetProcessListAll(requestlist)
    .then(async (result: any[] | null) => {
        
      if (result != null) {
        
        let data = this.sortByKey(result, "srno").map((item: any) => ({
          ...item,
          deleteAllowed:
            item.deleteAllowed === true || item.DeleteAllowed === true,
        }));
          this.setState({ searcResult: data.slice(0) });
          this.setState({ isWait: false });
        // this.setState({ searcResult: result }, () => {
           
        // });
      }
      resolve();
    })
    .catch((err: any) => {
      toast.error(`Server Error, ${err}`);
      this.setState({ isWait: false });
      reject();
    });
  };

  shownewslideout = () => {
    this.setState({ showSlideout: true, productid: 0 });
  };

  closeSlideOut = () => {
    
    this.setState({ showSlideout: false });
    
  };
  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      
      this.setState({
        showSlideout: true, productid: row.id
      });


    },
  };
  discard = () => {
    let requestlist = { ...this.state.requestlist };
        this.getprocessMaster(requestlist);
    this.setState({ isSaveOpen: false, duplicateSrNos: [] }, () => {
       
    });
  };

  getImportCellValue = (row: any, keys: string[]) => {
    if (!row) return "";
    const rowKeys = Object.keys(row);
    for (let i = 0; i < keys.length; i++) {
      const wanted = keys[i].toLowerCase().replace(/\s|\./g, "");
      const match = rowKeys.find(
        (k) => String(k).toLowerCase().replace(/\s|\./g, "") === wanted
      );
      if (match != null && row[match] != null && String(row[match]).trim() !== "") {
        return String(row[match]).trim();
      }
    }
    return "";
  };

  parseYesNoFlag = (value: any, defaultValue: number) => {
    if (value == null || String(value).trim() === "") return defaultValue;
    const v = String(value).trim().toLowerCase();
    if (["1", "yes", "y", "true", "active", "on"].includes(v)) return 1;
    if (["0", "no", "n", "false", "inactive", "off"].includes(v)) return 0;
    const num = Number(v);
    if (!isNaN(num)) return num === 0 ? 0 : 1;
    return defaultValue;
  };

  exportProcesses = () => {
    const rows = (this.state.searcResult || []).map((r: any, index: number) => ({
      "Sr No.": index + 1,
      "Process Name": r.processName || "",
      Description: r.pDescription || "",
      "Ledger Code": r.ledgercode || "",
      "Outside Services": Number(r.isFixed) === 1 ? "Yes" : "No",
      Active: Number(r.status) === 1 ? "Yes" : "No",
    }));

    if (rows.length === 0) {
      toast.error("No processes to export.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "userManagementHierarchy",
      });
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Process Master");
    XLSX.writeFile(
      workbook,
      `ProcessMaster_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
    );
    toast.success(`Exported ${rows.length} process(es).`, {
      position: toast.POSITION.BOTTOM_RIGHT,
      containerId: "userManagementHierarchy",
    });
  };

  downloadImportTemplate = () => {
    // Sheet 1: prefilled sample processes for import guidance
    const templateRows = PROCESS_MASTER_TEMPLATE_ROWS.map((row) => ({ ...row }));

    // Sheet 2: defines what to add in each Excel column
    const instructionRows = [
      {
        "Column Name": "Process Name",
        "What to Add": "Unique process name (required). Do not repeat an existing Process Name.",
        "Example": "Material Receiving",
        "Allowed Values": "Any text",
      },
      {
        "Column Name": "Description",
        "What to Add": "Short description of the process (optional).",
        "Example": "Receive and inspect incoming raw materials and components",
        "Allowed Values": "Any text",
      },
      {
        "Column Name": "Ledger Code",
        "What to Add": "Ledger / GL code for the process (optional).",
        "Example": "LC001",
        "Allowed Values": "Any text",
      },
      {
        "Column Name": "Outside Services",
        "What to Add": "Whether this is an outside / external service.",
        "Example": "No",
        "Allowed Values": "Yes or No (also 1/0, True/False)",
      },
      {
        "Column Name": "Active",
        "What to Add": "Whether the process is active.",
        "Example": "Yes",
        "Allowed Values": "Yes or No (also 1/0, Active/Inactive). Default is Yes if blank.",
      },
      {
        "Column Name": "",
        "What to Add": "",
        "Example": "",
        "Allowed Values": "",
      },
      {
        "Column Name": "Import Steps",
        "What to Add": "1. Open sheet 'Process Master' — rows are prefilled with sample processes.",
        "Example": "",
        "Allowed Values": "",
      },
      {
        "Column Name": "",
        "What to Add": "2. Edit, add, or remove rows as needed. Keep column headers exactly as given.",
        "Example": "",
        "Allowed Values": "",
      },
      {
        "Column Name": "",
        "What to Add": "3. Process Name is required and must be unique (duplicates are skipped on import).",
        "Example": "",
        "Allowed Values": "",
      },
      {
        "Column Name": "",
        "What to Add": "4. Save as .xlsx or .csv, then click Import on Process Master.",
        "Example": "",
        "Allowed Values": "",
      },
      {
        "Column Name": "",
        "What to Add": "5. Review imported rows and click Save Changes.",
        "Example": "",
        "Allowed Values": "",
      },
    ];

    const dataSheet = XLSX.utils.json_to_sheet(templateRows);
    dataSheet["!cols"] = [
      { wch: 40 },
      { wch: 70 },
      { wch: 18 },
      { wch: 18 },
      { wch: 12 },
    ];

    const instructionSheet = XLSX.utils.json_to_sheet(instructionRows);
    instructionSheet["!cols"] = [
      { wch: 20 },
      { wch: 75 },
      { wch: 55 },
      { wch: 45 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, dataSheet, "Process Master");
    XLSX.utils.book_append_sheet(workbook, instructionSheet, "Instructions");
    XLSX.writeFile(workbook, "ProcessMaster_Import_Template.xlsx");

    toast.success(
      `Import template downloaded with ${templateRows.length} prefilled process(es).`,
      {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "userManagementHierarchy",
      }
    );
  };

  triggerImportFile = () => {
    if (this.importFileInputRef && this.importFileInputRef.current) {
      this.importFileInputRef.current.click();
    }
  };

  onImportFileSelected = (e: any) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;

    const fileName = String(file.name || "").toLowerCase();
    if (
      !fileName.endsWith(".xlsx") &&
      !fileName.endsWith(".xls") &&
      !fileName.endsWith(".csv")
    ) {
      toast.error("Please import an Excel (.xlsx/.xls) or CSV file.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "userManagementHierarchy",
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = (evt: any) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonRows = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });
        this.applyImportedRows(jsonRows);
      } catch (err) {
        toast.error("Failed to read import file.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "userManagementHierarchy",
        });
      }
    };
    reader.readAsArrayBuffer(file);
  };

  applyImportedRows = (jsonRows: any[]) => {
    if (!Array.isArray(jsonRows) || jsonRows.length === 0) {
      toast.error("Import file has no data rows.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "userManagementHierarchy",
      });
      return;
    }

    const searcResult = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.searcResult || []))
    );
    const existingNames = new Set(
      searcResult
        .map((r: any) => String(r.processName || "").trim().toLowerCase())
        .filter((n: string) => n !== "")
    );

    let maxSrno =
      searcResult.length > 0
        ? Math.max(...searcResult.map((o: any) => Number(o.srno) || 0), 0)
        : 0;

    let importedCount = 0;
    let skippedEmpty = 0;
    const skippedDuplicates: string[] = [];
    const seenInFile = new Set<string>();

    jsonRows.forEach((row: any) => {
      const processName = this.getImportCellValue(row, [
        "Process Name",
        "ProcessName",
        "process name",
        "process_name",
        "Name",
      ]);
      if (!processName) {
        skippedEmpty += 1;
        return;
      }

      const nameKey = processName.toLowerCase();
      if (existingNames.has(nameKey) || seenInFile.has(nameKey)) {
        if (!skippedDuplicates.some((n) => n.toLowerCase() === nameKey)) {
          skippedDuplicates.push(processName);
        }
        return;
      }

      const pDescription = this.getImportCellValue(row, [
        "Description",
        "PDescription",
        "pDescription",
        "process_description",
        "process description",
      ]);
      const ledgercode = this.getImportCellValue(row, [
        "Ledger Code",
        "LedgerCode",
        "ledgercode",
        "ledger_code",
      ]);
      const isFixed = this.parseYesNoFlag(
        this.getImportCellValue(row, [
          "Outside Services",
          "OutsideServices",
          "isFixed",
          "External",
          "outside_services",
        ]),
        0
      );
      const status = this.parseYesNoFlag(
        this.getImportCellValue(row, [
          "Active",
          "status",
          "Status",
        ]),
        1
      );

      maxSrno += 1;
      seenInFile.add(nameKey);
      existingNames.add(nameKey);
      searcResult.push({
        id: 0,
        processName,
        pDescription,
        ledgercode,
        isFixed,
        status,
        srno: maxSrno,
        deleteAllowed: true,
        tenantid: searcResult[0] ? searcResult[0].tenantid : undefined,
      });
      importedCount += 1;
    });

    if (importedCount === 0) {
      const dupPreview = skippedDuplicates.slice(0, 5).join('", "');
      const dupMore =
        skippedDuplicates.length > 5
          ? `; and ${skippedDuplicates.length - 5} more`
          : "";
      toast.error(
        skippedDuplicates.length > 0
          ? `No rows imported. Duplicate Process Name(s): "${dupPreview}"${dupMore}`
          : "No valid rows to import. Process Name is required.",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "userManagementHierarchy",
          autoClose: 10000,
        }
      );
      return;
    }

    this.setState(
      {
        searcResult: [],
      },
      () => {
        this.setState({
          searcResult,
          isSaveOpen: true,
          isStateChanged: true,
          duplicateSrNos: [],
          tableRefresh: !this.state.tableRefresh,
        });
      }
    );

    const parts: string[] = [`Imported ${importedCount} process(es).`];
    if (skippedDuplicates.length > 0) {
      const dupPreview = skippedDuplicates.slice(0, 5).join('", "');
      const dupMore =
        skippedDuplicates.length > 5
          ? `; and ${skippedDuplicates.length - 5} more`
          : "";
      parts.push(
        `Skipped ${skippedDuplicates.length} duplicate Process Name(s): "${dupPreview}"${dupMore}.`
      );
    }
    if (skippedEmpty > 0) {
      parts.push(`Skipped ${skippedEmpty} row(s) with empty Process Name.`);
    }
    parts.push("Review and click Save Changes.");

    toast.success(parts.join(" "), {
      position: toast.POSITION.BOTTOM_RIGHT,
      containerId: "userManagementHierarchy",
      autoClose: 12000,
    });
  };

  saveApi = () => {
    let { searcResult } = this.state;
  
    this.setState({ isWait: true });
    let processlistItem: any = [];
    searcResult.forEach((items: any, index: any) => {
      let newIndex = index + 1;
     
      let item: any = {};


      item.Id = items.id ==null ?0 :items.id ;
      item.ProcessName = items.processName;
      item.srno =newIndex;
      item.PDescription = items.pDescription;
      item.Tenantid = items.tenantid;
      item.status=items.status;
      item.isFixed = items.isFixed;
      item.ledgercode=items.ledgercode;
      processlistItem.push(item);
    });

    const emptySrNos = processlistItem
      .filter((x) => x.ProcessName == null || String(x.ProcessName).trim() === "")
      .map((x) => x.srno);

    if (emptySrNos.length > 0) {
      this.setState({ isWait: false, duplicateSrNos: emptySrNos });
      toast.error(
        `Empty Process Name at Sr No. ${emptySrNos.join(", ")}`,
        { position: toast.POSITION.BOTTOM_RIGHT, containerId: "userManagementHierarchy" }
      );
      setTimeout(() => {
        const el = document.getElementById("txtprocess" + emptySrNos[0] + "txt");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus();
        }
      }, 100);
      return;
    }

    // Process Name must be unique (description is ignored for duplicate check).
    const nameToSrNos: { [key: string]: { displayName: string; srnos: number[] } } = {};
    processlistItem.forEach((item) => {
      const name = String(item.ProcessName || "").trim();
      const key = name.toLowerCase();
      if (!nameToSrNos[key]) {
        nameToSrNos[key] = { displayName: name, srnos: [] };
      }
      nameToSrNos[key].srnos.push(item.srno);
    });

    const duplicateSrNos: number[] = [];
    const duplicateMessages = Object.keys(nameToSrNos)
      .filter((key) => nameToSrNos[key].srnos.length > 1)
      .map((key) => {
        const entry = nameToSrNos[key];
        duplicateSrNos.push(...entry.srnos);
        return `"${entry.displayName}" (Sr No. ${entry.srnos.join(", ")})`;
      });

    if (duplicateMessages.length > 0) {
      this.setState({ isWait: false, duplicateSrNos, tableRefresh: !this.state.tableRefresh });
      const preview = duplicateMessages.slice(0, 5).join("; ");
      const moreCount = duplicateMessages.length - 5;
      const message =
        moreCount > 0
          ? `Duplicate Process Name (${duplicateMessages.length}): ${preview}; and ${moreCount} more.`
          : `Duplicate Process Name: ${preview}`;
      toast.error(message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "userManagementHierarchy",
        autoClose: 12000,
      });
      setTimeout(() => {
        const firstSrno = duplicateSrNos[0];
        const el = document.getElementById("txtprocess" + firstSrno + "txt");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus();
        }
      }, 100);
      return;
    }

    this.setState({ duplicateSrNos: [] });
  
    PartTemplateService.Saveprocess(processlistItem).then(
      async (result: any | null) => {
        
          let requestlist = { ...this.state.requestlist };
          this.getprocessMaster(requestlist);
        
          toast.success("Process updated",
            { position: toast.POSITION.BOTTOM_RIGHT, containerId: "userManagementHierarchy" });
          
            this.setState({ isSaveOpen: false, loading: false, isWait: false, duplicateSrNos: [] });
      }
    ).catch((err: any) => {
      const errorMsg = extractValidationErrors(err, "Failed to save process");
      toast.error(errorMsg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "userManagementHierarchy",
      });
      this.setState({ isWait: false });
    });

  };

    render() { 
      const { permissions } = this.props; 
    const hasAddPermission = permissions && permissions['Process Master'] ? permissions['Process Master'].includes('Add Process') : false;
    const hasEditPermission = permissions && permissions['Process Master'] ? permissions['Process Master'].includes('Edit Process') : false;
    const hasDeletePermission = permissions && permissions['Process Master'] ? permissions['Process Master'].includes('Delete Process') : false;
      const customTotal = (from, to, size) => (
        <span className="text-muted">
          Showing {from} to {to} of {size} entries
        </span>
      );
      const options = {
  
        showTotal: true,
        hideSizePerPage: false,
        hidePageListOnlyOnePage: true,
        paginationTotalRenderer: customTotal,
        disablePageTitle: true,
        sizePerPageList: [{
          text: '10', value: 10
        },
        {
          text: '25', value: 25
        },
        {
          text: '50', value: 50
        },
  
        {
          text: 'All', value: this.state.searcResult.length
        }] // A numeric array is also available. the purpose of above example is custom the text
      };
      let confirmModalContent = [
        {
          title: "Delete Row",
          desc: "Are you sure you want to delete?",
          cancleAction: "Cancel",
          ActionTrue: "Delete",
        },
      ];

       const templateColumns = [

        {
          dataField: 'srno',
          text: 'Sr No.',
          headerStyle: { width: '50px' },
          formatter: (cell: any, row: any, rowIndex: any) => {
    
            return (
              <div>
                {rowIndex + 1}
              </div>
            );
          },
        },
        {
          dataField: "isSelected",
          text: "",
          classes: "expanding-bar",
          headerStyle: { width: '10px' },
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <div className="d-flex align-items-center txt-bold">
    
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="toolp">Click to move up this step</Tooltip>
                  }
                >
                  <FontAwesomeIcon
                    icon={faArrowUp}
                    size="xs"
                    onClick={(e) => this.handleRowOrdering(e, row, 'up')}
                  />
                </OverlayTrigger>
              </div>
            );
          },
        },
    
        {
          dataField: "isSelected",
          text: "",
          classes: "expanding-bar",
          headerStyle: { width: '10px' },
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <div className="d-flex align-items-center txt-bold">
    
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="toolp">Click to move down this step</Tooltip>
                  }
                >
                  <FontAwesomeIcon
                    icon={faArrowDown}
                    size="xs"
                    onClick={(e) => this.handleRowOrdering(e, row, 'down')}
                  />
                </OverlayTrigger>
              </div>
            );
          },
        },
    
        {
          dataField: 'process',
          text: 'Process Name',
          headerStyle: { width: '250px' },
          hidden: false,
          editable: false,
          headerAttrs: (column, colIndex) => (
            { 'tabIndex': '-1' }
          ),
          formatter: (cell: any, row: any, rowIndex: any) => {
            const isDuplicate =
              Array.isArray(this.state.duplicateSrNos) &&
              this.state.duplicateSrNos.some((n: any) => Number(n) === Number(row.srno));
            return (
              <div>
               <Form.Control
                        // tabIndex={this.state.tabEnable}
                         id={"txtprocess" + row.srno + "txt"}
                        type="text"
                        // placeholder="Enter Part No"
                        value={row.processName}
                          onChange={(e) => this.updateState(e, row.srno, "processName", row.srno)}
                        autoComplete="off"
                         disabled={ row.id > 0 && !hasEditPermission }
                        title={isDuplicate ? "Duplicate Process Name" : ""}
                        maxLength={100}
                        className={isDuplicate ? "is-invalid border-danger" : ""}
                        style={
                          isDuplicate
                            ? { borderColor: "#dc3545", boxShadow: "0 0 0 0.2rem rgba(220,53,69,.25)", backgroundColor: "#fff5f5" }
                            : undefined
                        }
                      />
                {isDuplicate && (
                  <div className="invalid-feedback d-block" style={{ fontSize: "11px" }}>
                    Duplicate Process Name
                  </div>
                )}

              </div>
    
            );
    
    
    
          },
        },
        {
          dataField: 'description',
          text: 'Description',
          headerStyle: { width: '550px' },
        
          hidden: false,
          editable: false,
          headerAttrs: (column, colIndex) => (
            { 'tabIndex': '-1' }
          ),
          formatter: (cell: any, row: any, rowIndex: any) => {
         
            return (
             <div>
 <Form.Control
                        // tabIndex={this.state.tabEnable}
                        id={"txtdes" + row.srno + "txt"}
                        type="text"
                        // placeholder="Enter Part No"
                        value={row.pDescription}
                          onChange={(e) => this.updateState(e, row.srno, "Description", row.srno)}
                        autoComplete="off"
                       disabled={ row.id > 0 && !hasEditPermission }
                        title=""
                        maxLength={500}
                      />
             </div>
            );
    
    
    
          },
    
        },
        {
          dataField: 'ledgercode',
          text: 'Ledger Code',
          headerStyle: { width: '100px' },
          hidden: false,
          editable: false,
          headerAttrs: (column, colIndex) => (
            { 'tabIndex': '-1' }
          ),
          formatter: (cell: any, row: any, rowIndex: any) => {
           
            return (
              <div>
               <Form.Control
                        // tabIndex={this.state.tabEnable}
                         id={"txtledgercode" + row.srno + "txt"}
                        type="text"
                        // placeholder="Enter Part No"
                        value={row.ledgercode}
                          onChange={(e) => this.updateState(e, row.srno, "ledgercode", row.srno)}
                        autoComplete="off"
                        disabled={ row.id > 0 && !hasEditPermission }
                        title=""
                        maxLength={500}
                      />

              </div>
    
            );
    
    
    
          },
        },
      
    
        // {
        //   dataField: 'isFixed',
        //   text: 'External',
        //   headerStyle: { width: '50px' },
        //   hidden: false,
        //   editable: false,
        //   headerAttrs: (column, colIndex) => (
        //     { 'tabIndex': '-1' }
        //   ),
        //   formatter: (cell: any, row: any, rowIndex: any) => {
        //     let id = "txtdescription" + rowIndex + "txt";
        //     let disable = false;
        //     return (
        //       <div>
        //      <Form.Check
        //         className="knob"
        //                 // tabIndex={this.state.tabEnable}
        //                 id={"txtIsFixed" + rowIndex + "txt"}
        //               type="switch"
        //                 checked={row.isFixed}
        //                 // placeholder="Enter Part No"
        //                 //value={value.pDescription}
        //                   onChange={(e) => this.updateState(e, rowIndex, "IsFixed", rowIndex)}
        //                 autoComplete="off"
        //                // disabled={ row.id==6 ? true: false }
        //                 title=""
        //                 //maxLength={500}
        //               />
        //     </div>
          

      


    
        //     );
    
    
    
        //   },
    
        // },

        {
          dataField: 'isFixed',
          text: 'Outside Services',
          headerStyle: { width: '80px' },
          hidden: false,
          headerClasses: 'text-center',
          classes: 'text-center',
          
          editable: false,
          headerAttrs: (column, colIndex) => (
            { 'tabIndex': '-1' }
          ),
          formatter: (cell: any, row: any, rowIndex: any) => {
            let id = "txtdescription" + rowIndex + "txt";
            let disable = false;
            return (
              <div>
                   <Form.Check
                className="knob"
                        // tabIndex={this.state.tabEnable}
                        id={"txtIsFixed" + row.srno + "txt"}
                        type="switch"
                        checked={row.isFixed}
                        // placeholder="Enter Part No"
                        //value={value.pDescription}
                          onChange={(e) => this.updateState(e, row.srno, "IsFixed", row.srno)}
                        autoComplete="off"
                       disabled={ row.id > 0 && !hasEditPermission }
                        title=""
                        //maxLength={500}
                      />

              </div>
    
            );
    
    
    
          },
    
        },
        {
          dataField: 'status',
          text: 'Active',
          headerClasses: 'text-center',
          classes: 'text-center',
          
          headerStyle: { width: '80px' },
          hidden: false,
          editable: false,
          headerAttrs: (column, colIndex) => (
            { 'tabIndex': '-1' }
          ),
          formatter: (cell: any, row: any, rowIndex: any) => {
            let id = "txtdescription" + rowIndex + "txt";
            let disable = false;
            return (
              <div>
                   <Form.Check
                className="knob"
                        // tabIndex={this.state.tabEnable}
                        id={"txtstatus" + row.srno + "txt"}
                        type="switch"
                        checked={row.status}
                        // placeholder="Enter Part No"
                        //value={value.pDescription}
                          onChange={(e) => this.updateState(e, row.srno, "status", row.srno)}
                        autoComplete="off"
                       disabled={ row.id > 0 && !hasEditPermission }
                        title=""
                        //maxLength={500}
                      />

              </div>
    
            );
    
    
    
          },
    
        },
        {
          dataField: 'Attachment',
          text: '',
          //headerFormatter: this.iconFormatter,
          headerAttrs: (column, colIndex) => (
            { 'tabIndex': '-1' }
          ),
          formatter: (cell: any, row: any, rowIndex: any) => {
            let confirmModalContent = [
              {
                title: "Delete Row",
                desc: "Are you sure you want to delete?",
                cancleAction: "Cancel",
                ActionTrue: "Delete",
              },
            ];
    
            // Unsaved new rows always show Delete (discard draft).
            // After save, Delete shows only when the process is unused and user has Delete permission.
            const isNewUnsavedRow = !row.id || Number(row.id) <= 0;
            const isDeleteAllowed =
              row.deleteAllowed === true ||
              row.DeleteAllowed === true ||
              row.deleteAllowed === 1 ||
              row.DeleteAllowed === 1;

            if (
              !isNewUnsavedRow &&
              (!isDeleteAllowed || !hasDeletePermission)
            ) {
              return (
                <div></div>
              );
            }

            return (
                <Dropdown
             className="more-action confirmation-modal"
              
              //tabIndex={this.state.tabDisable}
            >
              <Dropdown.Toggle
                className="btn-outline-primary btn btn-primary more fa-trash"
                id="dropdown-more-delete"
              //  tabIndex={this.state.tabDisable}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M5 5.83329C4.53917 5.83329 4.16667 5.83329 4.16667 5.83329V16.6666C4.16667 17.5866 4.91333 18.3333 5.83333 18.3333H14.1667C15.0867 18.3333 15.8333 17.5866 15.8333 16.6666V5.83329C15.8333 5.83329 15.4608 5.83329 15 5.83329H5ZM8.33333 15.8333H6.66667V8.33329H8.33333V15.8333ZM13.3333 15.8333H11.6667V8.33329H13.3333V15.8333ZM13.8483 3.33329L12.5 1.66663H7.5L6.15167 3.33329H2.5V4.99996H6.66667H13.3333H17.5V3.33329H13.8483Z" />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ConfirmationModal
                  confirmModalContent={confirmModalContent}
                  ishandleDeletePosition={this.ishandleDeleteRow.bind(
                    this,
                    row
                  )}
                />
              </Dropdown.Menu>
            </Dropdown>
              );
          },
        },
    
      ];

      const {

        showSlideout,
  
      } = this.state;
      

//       const SortableItem = SortableElement<{ value: any, idx: any }>(({ value, idx }) => (
//         <div className="row" style={{ cursor: "move" }}>
//           <div className="col-sm-1 td">
//             <div className="tdBody diwidth20">{idx + 1}</div>
//           </div>
//           <div className="col-sm-3 td">
          
      
//             <div className="tdBody">
//                       <Form.Control
//                         // tabIndex={this.state.tabEnable}
//                          id={"txtprocess" + idx + "txt"}
//                         type="text"
//                         // placeholder="Enter Part No"
//                         value={value.processName}
//                           onChange={(e) => this.updateState(e, idx, "processName", idx)}
//                         autoComplete="off"
//                          disabled={ false }
//                         title=""
//                         maxLength={500}
//                       />
//                     </div>
            
//           </div>
//           <div className="col-sm-4 td">
           
//            <div className="tdBody">
//                       <Form.Control
//                         // tabIndex={this.state.tabEnable}
//                         id={"txtdes" + idx + "txt"}
//                         type="text"
//                         // placeholder="Enter Part No"
//                         value={value.pDescription}
//                           onChange={(e) => this.updateState(e, idx, "Description", idx)}
//                         autoComplete="off"
//                        // disabled={ row.id==6 ? true: false }
//                         title=""
//                         maxLength={500}
//                       />
                   
              
//               </div>
//           </div>
//           <div className="col-sm-1 td">
//           <div className="tdBody">
//           <Form.Control
//                 className="knob"
//                         // tabIndex={this.state.tabEnable}
//                         id={"txtstatus" + idx + "txt"}
//                         type="checkbox"
//                         checked={value.status}
//                         // placeholder="Enter Part No"
//                         //value={value.pDescription}
//                           onChange={(e) => this.updateState(e, idx, "status", idx)}
//                         autoComplete="off"
//                        // disabled={ row.id==6 ? true: false }
//                         title=""
//                         //maxLength={500}
//                       />
//            </div>
//           </div>
//           <div className="col-sm-1 td">
//           <div className="tdBody">
//           <Form.Control
//                 className="knob"
//                         // tabIndex={this.state.tabEnable}
//                         id={"txtIsFixed" + idx + "txt"}
//                         type="checkbox"
//                         checked={value.isFixed}
//                         // placeholder="Enter Part No"
//                         //value={value.pDescription}
//                           onChange={(e) => this.updateState(e, idx, "IsFixed", idx)}
//                         autoComplete="off"
//                        // disabled={ row.id==6 ? true: false }
//                         title=""
//                         //maxLength={500}
//                       />
//            </div>
//           </div>
//           <div className="col-sm-1 td" >
//           <div className="tdBody">
//          { value.deleteAllowed &&  
           
    
           
//             <>
           
//             <Button className="gg-remove" onClick=
//            // {(e)=>{ this.deleteProcess(value.srno);}}
//            {this.ishandleDeleteRow.bind(
//             this,
//           value
//           )}  
//             >
//              Delete
//             </Button>
// {/* <i className="fa fa-trash" ></i> */}
// {/* <i
//    onClick={(e)=>{ this.deleteProcess(value.id);}}
//   className="far fa-trash-alt ml-auto"
// /> */}

//        {/* <Button
//                           type="button"
//                           className="btn-ghost mr-auto dx-button"
                         
//                           onClick={(e)=>{ this.deleteProcess(value.id);}}
//                         >
//                           <MdDelete className=".dx-icon align-top lh-1'"   onClick={(e)=>{ this.deleteProcess(value.id);}} size={20} /> 
//                         </Button> 
//         */}
            
//                 </>
           
//          }
//            </div>
//           </div>
//         </div>
//       ));
      
      
      // const DragHandle = SortableHandle(() => <span>::</span>);
      // const SortableList = SortableContainer<{ searcResult: [] }>(({ searcResult }) => {
      //   searcResult = searcResult || [];
      //   return (
      //     <div className="tableTbody">
      //       {(searcResult || [])?.map((value, index) => (
              
      //         <SortableItem key={index} idx={index} index={index} value={value} />
      //       ))}
      //     </div>
      //   );
      // });
      
      let { searcResult, isSaveOpen, loading, isWait, d } = this.state;


        return (

          
            <>
<React.Fragment>


        
          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex">
            
          Process Master
            <div className="action-group d-flex flex-row ml-auto">
              <input
                type="file"
                accept=".xlsx,.xls,.csv"
                ref={this.importFileInputRef}
                style={{ display: "none" }}
                onChange={this.onImportFileSelected}
              />
              <Dropdown className="more-action">
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary more"
                  id="dropdown-more-process-master"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {(hasAddPermission || hasEditPermission) && (
                    <>
                      <Dropdown.Item onClick={this.downloadImportTemplate}>
                        Template
                      </Dropdown.Item>
                      <Dropdown.Item onClick={this.triggerImportFile}>
                        Import
                      </Dropdown.Item>
                    </>
                  )}
                  <Dropdown.Item onClick={this.exportProcesses}>
                    Export
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              </div>
              </div>
              <ToastContainer
          enableMultiContainer
          autoClose={3000}
          containerId={"userManagementHierarchy"}
        />
     
        {/* <div className="hierarchyDragableTable">
          <div className="tableThead">
            <div className="row hasBorder">
              <div className="col-sm-1 th">
                Order
              </div>
              <div className="col-sm-3 th">
                 Process Name 
              </div>
              <div className="col-sm-4 th">
                Description 
              </div>
              <div className="col-sm-1 th">
                 Status 
              </div>
              <div className="col-sm-1 th">
                 External 
              </div>
              <div className="col-sm-1 th">
                  
              </div>
            </div>
          </div>

          <div
            className={`${isSaveOpen ? "hasFixedAction hasTable" : "hasTable"}`}
          >
            {loading ? (
              ""
            ) : (
              <>
              

                <SortableList
                  helperClass="sortableHelper"
                  axis="y"
                  lockAxis="y"
                  searcResult={searcResult}
                  onSortEnd={this.onSortEnd}
                  onSortStart={this.startState}
                  onSortMove={this.onSortMove}
                />
                 
              </>
            )}
          </div>
            <div className="d-flex align-items-center justify-content-end height-20">
                  <div className="d-flex action-btn align-items-center">
                  <Button
                          type="button"
                          className="btn-ghost mr-auto"
                          onClick={this.handleNewRow}
                        >
                          <FaCirclePlus className="align-middle lh-1`" /> <span className="align-middle lh-1">Add Row</span>
                        </Button>
                   </div>
                 </div>
                 </div> */}

{this.state.searcResult.length > 0 && (
 <div className="table-responsive table-responsive1" >
                <section className="pb-3">
                <div
                          className="table table-borderless align-middle transactions-list"

                        >
<BootstrapTable
  key={this.state.tableRefresh} 
  id="tbltemplate2"
  keyField="srno"
  data={this.state.searcResult}
  columns={templateColumns}
 // pagination={paginationFactory(options)}
/>
</div>
</section>
</div>

)}


{hasAddPermission &&
<div className="d-flex align-items-center justify-content-end height-20">
                  <div className="d-flex action-btn align-items-center">
                  <Button
                          type="button"
                          className="btn-ghost mr-auto"
                          onClick={this.handleNewRow}
                        >
                          <FaCirclePlus className="align-middle lh-1`" /> <span className="align-middle lh-1">Add Row</span>
                        </Button>
                   </div>
                 </div>
    }             
                 <div className="filter-sec height-172">

<br></br>
<br></br>

</div>
                 <div className="d-flex align-items-center justify-content-end height-20"
                
                 >
          {isSaveOpen && (
           <div className="TabFooter-Pay"
           style={{ minWidth: "83.7%", width: "992px", maxWidth: "100%" }}
           >
              <div className="bulkSelectFooter">
                <div className="mr-auto message">
                  <span>You have unsaved changes</span>
                </div>
                <button
                  type="button"
                   onClick={this.discard}
                  className="btn btn-primary btn-discard"
                >
                  Discard
                </button>
                {(hasEditPermission ||  hasAddPermission) &&
                <button
                  type="button"
                  disabled={isWait}
                   onClick={this.saveApi}
                  className="btn btn-primary"
                >
                  {isWait ? "Loading..." : "Save Changes"}
                </button>
               }
              </div>
            </div>
          )}
         </div>


   </Container>
       
   {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}
    
      </React.Fragment>
            </>
        );
    }

}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
});

export default connect(mapStateToProps)(ProcessMaster);
